module.exports = __webpack_public_path__ + "img/visit-lighter.c318694f.svg";